/* eslint-disable react/jsx-one-expression-per-line */
import classNames from 'classnames'
import { TAppealOffer } from 'feature/appeals/type'
import { formatPriceInRubles } from 'helpers/formatPrice'

import { DropDownBlock } from '../../DropDownBlock/DropDownBlock'

import style from './OfferItem.module.scss'

type TOfferItem = {
  offer: TAppealOffer
}

// информация о составе КП

export function OfferItem({ offer }: TOfferItem) {
  return (
    <div className={style.offerItem}>
      {offer.products.map((product, index) => (
        <div className={style.product} key={index}>
          <div className={style.productInf}>
            <div className={style.productFeatures}>
              <span className={style.productName}>{product.name}</span>
              <span className={style.productCount}>{product.count} шт</span>
              <span className={classNames('h4', style.productPrice)}>
                {formatPriceInRubles(product.price)}
              </span>
            </div>
          </div>
          {product.parameters.length > 0 && (
            <div className={style.productParams}>
              <DropDownBlock
                title='Параметры'
                isChildren
                className={style.paramsDropDown}
              >
                <div className={style.productParamsList}>
                  {product.parameters.map((parameter, paramIndex) => (
                    <div key={paramIndex} className={style.productParameter}>
                      <span
                        className={classNames(
                          'text-default',
                          style.parameterName,
                        )}
                      >
                        {parameter.name}
                      </span>
                      <span
                        className={classNames(
                          'text-default',
                          style.productParameterValue,
                        )}
                      >
                        {parameter.value}
                      </span>
                    </div>
                  ))}
                </div>
              </DropDownBlock>
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
